export default {
  en: 'English',
  ja: 'Japanese',
  nl: 'Dutch',
  zh: 'Chinese - 中文',
};
